<template>
  <CollapsibleSection
    buttonText="Supported MFA"
    :class="$style.wrapper"
    iconPosition="left"
    :isExpanded="isExpanded"
    @expand="handleToggleExpanded"
  >
    <template
      v-slot:content
    >
      <LoadingIcon
        v-if="isLoading"
      />
      <template
        v-else
      >
        <MfaStatusIndicator
          v-for="config in configs"
          :key="config.type"
          :value="config"
        />
      </template>
    </template>
  </CollapsibleSection>
</template>

<script>
import { CollapsibleSection, LoadingIcon } from '@jumpcloud/ui-components';

import MfaStatusIndicator from 'client/components/MfaStatusIndicator';

export default {
  name: 'SupportedMfa',

  components: {
    CollapsibleSection,
    LoadingIcon,
    MfaStatusIndicator,
  },

  props: {
    configs: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isExpanded: true,
    };
  },

  methods: {
    handleToggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style module>
  .wrapper {
    margin-top: 2rem;
  }
</style>
